// components/AdminLayout.js
import AdminNavbar from '../Admin/AdminNavbar';
import AdminSidebar from '../Admin/AdminSidebar';

const AdminLayout = ({ children }) => {
  return (
    <>
      <AdminNavbar />
      <div style={{ display: 'flex' }}>
        <AdminSidebar />
        <div style={{ flex: 1, marginLeft: '265px' ,padding: '20px' }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default AdminLayout;